import promoRestService from '../../services/PromoRestService';
export const getRewardTransactions = async (data) => {
  try {
    const response = await promoRestService?.post(
      'api/v1/adm/rewardTransaction/list',
      data
    );

    if (response?.status === 200)
      return {
        success: true,
        data: response?.data || null,
      };
  } catch (error) {
    return {
      success: false,
      data: null,
    };
  }
};

export const getRewardsMaster = async (data) => {
  try {
    const response = await promoRestService.post(
      'api/v1/adm/rewardType/list',
      data
    );

    if (response?.status === 200)
      return {
        success: true,
        data: response?.data || null,
      };
  } catch (error) {
    return {
      success: false,
      data: null,
    };
  }
};

export const createOrUpdateReward = async (data) => {
  try {
    const response = await promoRestService?.post(
      'api/v1/adm/rewardType/createOrUpdate',
      data
    );

    if (response?.status === 201) {
      return response?.data;
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: 'Failed, Please try again later',
    };
  }
};

export const getRewardTypeDetails = async (data) => {
  try {
    const response = await promoRestService?.post(
      `api/v1/adm/rewardType/details`,
      data
    );

    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: 'Failed, Please try again later',
    };
  }
};
